import { GlobalSearchListItemIcon } from './components/GlobalSearchListItemIcon'
import { GlobalSearchListItemMetadata } from './components/GlobalSearchListItemMetadata'
import { GlobalSearchListItemTitle } from './components/GlobalSearchListItemTitle'
import { GlobalSearchListItemContentStyled } from './styles/GlobalSearchListItemContentStyled'
import { GlobalSearchListItemLayoutStyled } from './styles/GlobalSearchListItemLayoutStyled'
import { type GlobalSearchResultTypeEnum } from '../../../../value-objects/enums'
import { type GlobalSearchItemMetadata } from '../../../../value-objects/GlobalSearchItemMetadata'

interface IGlobalSearchListItemProps {
  type: GlobalSearchResultTypeEnum
  id: string
  metadata: GlobalSearchItemMetadata
  extraIdentifier?: Nullable<string>
  onClick: () => void
}

export const GlobalSearchListItem = ({
  type,
  id,
  metadata,
  extraIdentifier,
  onClick,
}: IGlobalSearchListItemProps) => {
  return (
    <GlobalSearchListItemLayoutStyled onClick={onClick}>
      <GlobalSearchListItemIcon type={type} />
      <GlobalSearchListItemContentStyled>
        <GlobalSearchListItemTitle
          type={type}
          id={id}
          extraIdentifier={extraIdentifier}
        />
        <GlobalSearchListItemMetadata type={type} metadata={metadata} />
      </GlobalSearchListItemContentStyled>
    </GlobalSearchListItemLayoutStyled>
  )
}
